import { useMemo } from 'react';
import { getLiteral } from 'utils/getLiteral';
import { buildMarketingBulkSubscribeConfirmPayload } from './marketingBulkSubscribeConfig';

export default function useMarketingBulkSubscribeExtraActions({
    entity,
    filterKey,
    bulkSelectedEntities,
    selectedIds,
    onRequestBulkSubscribedConfirm,
    enabled = true,
}) {
    return useMemo(() => {
        if (!enabled || !entity || !onRequestBulkSubscribedConfirm) {
            return [];
        }

        return [
            {
                icon: 'verified',
                tooltip: getLiteral('label_marketing_campaigns_bulk_subscribe_tooltip'),
                onClick: () => {
                    const payload = buildMarketingBulkSubscribeConfirmPayload({
                        entity,
                        filterKey,
                        selectedIds,
                        bulkSelectedEntities,
                    });
                    if (payload) onRequestBulkSubscribedConfirm(payload);
                },
                isDisabled: bulkSelectedEntities === 0 || !filterKey,
                className: 'bulk-operation-give-consent',
            },
        ];
    }, [
        bulkSelectedEntities,
        enabled,
        entity,
        filterKey,
        onRequestBulkSubscribedConfirm,
        selectedIds,
    ]);
}
